import { render } from "./ProcuratDialog.vue?vue&type=template&id=6a65fdb9&scoped=true"
import script from "./ProcuratDialog.vue?vue&type=script&lang=js"
export * from "./ProcuratDialog.vue?vue&type=script&lang=js"

import "./ProcuratDialog.vue?vue&type=style&index=0&id=6a65fdb9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a65fdb9"]])

export default __exports__